'use client'
import { usePageNumberUpdator } from '@/app/hooks/usePageParamUpdater'
import { useTranslation } from '@/app/i18n/client'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useEffect, useState } from 'react'

interface SortOption {
  name: string
  id: string
}

interface SelectDropdownProps {
  selectFor?: string
  filterSort?: string
  order: string
  setOrder: (order: string) => void
}

const SelectDropDown = ({
  filterSort,
  setOrder,
  order,
  selectFor,
}: SelectDropdownProps) => {
  const [sortArray, setSortArray] = useState<SortOption[]>([])
  const goToPage = usePageNumberUpdator()

  const { t } = useTranslation()
  const sortOptions: SortOption[] = [
    { name: t('Ascending'), id: 'asc' },
    { name: t('Descending'), id: 'desc' },
  ]
  const NewsSort: SortOption[] = [
    { name: 'Publish Date', id: 'Publish Date' },
    { name: 'Title', id: 'Title' },
  ]
  const companySort: SortOption[] = [
    { name: 'Latest Company', id: 'Latest Company' },
    { name: 'Company Name', id: 'Company Name' },
  ]
  const productSort: SortOption[] = [
    { name: 'Publish Date', id: 'Publish Date' },
    { name: 'Importer Country', id: 'Importer Country' },
    { name: 'Product Name', id: 'Product Name' },
  ]
  const eventSort: SortOption[] = [
    { name: 'Upcoming', id: 'upcoming' },
    { name: 'Oldest', id: 'oldest' },
  ]
  useEffect(() => {
    if (filterSort === 'NewsSort') {
      setSortArray(NewsSort)
    } else if (filterSort === 'companySort') {
      setSortArray(companySort)
    } else if (filterSort === 'productSort') {
      setSortArray(productSort)
    } else if (filterSort === 'eventSort') {
      setSortArray(eventSort)
    } else {
      setSortArray(sortOptions)
    }
  }, [filterSort])
  return (
    <Select
      value={order}
      onValueChange={(e) => {
        setOrder(e)
        goToPage({ newPageNo: 1 })
      }}
    >
      <SelectTrigger className="w-[240px] !border-[1px] mobile:w-[100%]">
        <div className="text-xs font-ns_semibold w-full flex items-center">
          <span className="mr-1 text-xs text-[#8b8b8b]">
            {t(selectFor ? selectFor : 'Sort By')} {' :'}
          </span>
          <SelectValue />
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {sortArray.map((item: SortOption) => (
            <SelectItem
              className="text-xs font-ns_bold"
              value={item.id}
              key={item?.name}
            >
              {t(item.name)}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}

export default SelectDropDown
